/**
 * Zone de coaching URSSAF (réutilisabilité — Étape 9).
 *
 * Affichée dès qu'une entreprise active les « cadeaux réels ». Rappelle
 * l'obligation déclarative (avantage en nature), le process, et demande un
 * acquittement bloquant + horodaté. BizCoach ne fournit pas de conseil fiscal :
 * pointeur vers l'URSSAF / l'expert-comptable du client.
 */
import { useTranslation } from "react-i18next";
import { ShieldAlert, CheckCircle2 } from "lucide-react";

const GOLD_INK = "#926B00";
const GOLD_BG = "#FBF1D3";

export function UrssafNotice({
  acknowledged,
  ackAt,
  checked = false,
  onAcknowledge,
}: {
  acknowledged: boolean;
  ackAt?: string | null;
  checked?: boolean;
  onAcknowledge?: (checked: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border p-4" style={{ background: GOLD_BG, borderColor: `${GOLD_INK}55` }}>
      <div className="flex items-center gap-2 mb-2">
        <ShieldAlert className="h-5 w-5 shrink-0" style={{ color: GOLD_INK }} />
        <h4 className="font-semibold" style={{ color: GOLD_INK, fontFamily: "Sora, sans-serif" }}>{t("urssaf.title")}</h4>
      </div>
      <p className="text-sm mb-2" style={{ color: "#384872" }}>{t("urssaf.obligation")}</p>
      <ul className="text-sm list-disc pl-5 mb-2 space-y-1" style={{ color: "#384872" }}>
        <li>{t("urssaf.process1")}</li>
        <li>{t("urssaf.process2")}</li>
        <li>{t("urssaf.process3")}</li>
      </ul>
      <p className="text-xs italic mb-3" style={{ color: "#5C6785" }}>{t("urssaf.disclaimer")}</p>

      {acknowledged ? (
        <div className="flex items-center gap-2 text-sm font-medium" style={{ color: "#1E7A3C" }}>
          <CheckCircle2 className="h-4 w-4" />
          {ackAt
            ? t("urssaf.acknowledgedAt", { date: new Date(ackAt).toLocaleDateString() })
            : t("urssaf.acknowledged")}
        </div>
      ) : (
        <label className="flex items-start gap-2 text-sm cursor-pointer" style={{ color: "#384872" }}>
          <input
            type="checkbox"
            className="mt-0.5"
            checked={checked}
            onChange={(e) => onAcknowledge?.(e.target.checked)}
          />
          <span className="font-medium">{t("urssaf.ackLabel")}</span>
        </label>
      )}
    </div>
  );
}
